var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CardPage',{attrs:{"section":2,"page":7}},[_c('p',[_vm._v("\n        Let’s test your bios knowledge! Match the legacy (the description) with the legend (the person)!\n    ")]),_c('p',[_vm._v("\n        Ready?\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }